export const GET_RELATIONLOCATION_REQUEST = "GET_RELATIONLOCATION_REQUEST";
export const GET_RELATIONLOCATION_SUCCESS = "GET_RELATIONLOCATION_SUCCESS";
export const GET_RELATIONLOCATION_FAILURE = "GET_RELATIONLOCATION_FAILURE";

export const CREATE_RELATIONLOCATION_REQUEST =
  "CREATE_RELATIONLOCATION_REQUEST";
export const CREATE_RELATIONLOCATION_SUCCESS =
  "CREATE_RELATIONLOCATION_SUCCESS";
export const CREATE_RELATIONLOCATION_FAILURE =
  "CREATE_RELATIONLOCATION_FAILURE";

export const UPDATE_RELATION_LOCATION_REQUEST =
  "UPDATE_RELATION_LOCATION_REQUEST";
export const UPDATE_RELATION_LOCATION_SUCCESS =
  "UPDATE_RELATION_LOCATION_SUCCESS";
export const UPDATE_RELATION_LOCATION_FAILURE =
  "UPDATE_RELATION_LOCATION_FAILURE";

export const GET_UNMAPPED_WAREHOUSES_BY_LEVEL_REQUEST =
  "GET_UNMAPPED_WAREHOUSES_BY_LEVEL_REQUEST";
export const GET_UNMAPPED_WAREHOUSES_BY_LEVEL_SUCCESS =
  "GET_UNMAPPED_WAREHOUSES_BY_LEVEL_SUCCESS";
export const GET_UNMAPPED_WAREHOUSES_BY_LEVEL_FAILURE =
  "GET_UNMAPPED_WAREHOUSES_BY_LEVEL_FAILURE";

export const CREATE_UNMAPPED_WAREHOUSES_BY_LEVEL_REQUEST =
  "CREATE_UNMAPPED_WAREHOUSES_BY_LEVEL_REQUEST";
export const CREATE_UNMAPPED_WAREHOUSES_BY_LEVEL_SUCCESS =
  "CREATE_UNMAPPED_WAREHOUSES_BY_LEVEL_SUCCESS";
export const CREATE_UNMAPPED_WAREHOUSES_BY_LEVEL_FAILURE =
  "CREATE_UNMAPPED_WAREHOUSES_BY_LEVEL_FAILURE";

export const GET_MAPPED_WAREHOUSES_REQUEST = "GET_MAPPED_WAREHOUSES_REQUEST";
export const GET_MAPPED_WAREHOUSES_SUCCESS = "GET_MAPPED_WAREHOUSES_SUCCESS";
export const GET_MAPPED_WAREHOUSES_FAILURE = "GET_MAPPED_WAREHOUSES_FAILURE";
